import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreWebpage } from '@types';

const useGetWebpage = () => {
    const data = useStaticQuery(graphql`
        query AllWebpage {
            allPatstoreWebpage {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    gallery
    date
    state
    content
    path
    
                    }
                }
            }
        }
    
        `);


    const allWebpage: PatstoreWebpage[] =
        data.allPatstoreWebpage.edges.map(
            (edge: { node: PatstoreWebpage }) => edge.node
        ) || [];

    const findWebpage: (id: string) => PatstoreWebpage | undefined = (id: string) => {
        const result = allWebpage.find((item: PatstoreWebpage) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findWebpage,
        webpages: allWebpage,
    };
}; 

export default useGetWebpage;
